import { render } from "./QueueConfiguration.vue?vue&type=template&id=6c72ee34&scoped=true&lang=pug"
import script from "./QueueConfiguration.vue?vue&type=script&lang=js"
export * from "./QueueConfiguration.vue?vue&type=script&lang=js"

import "./QueueConfiguration.vue?vue&type=style&index=0&id=6c72ee34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c72ee34"]])

export default __exports__